import { Link } from 'react-router-dom';
import { BRAND } from '../config/brand';
import './SiteFooter.css';

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div className="site-footer-brand">
          <div className="site-footer-brandline">
            <i className="fas fa-crown site-footer-icon" aria-hidden="true"></i>
            <span className="site-footer-name">{BRAND.name}</span>
          </div>
          <div className="site-footer-meta">
            <a href={`mailto:${BRAND.supportEmail}`}>{BRAND.supportEmail}</a>
          </div>
        </div>

        <nav className="site-footer-links" aria-label="Footer">
          <Link to="/legal/terms">Terms</Link>
          <Link to="/legal/privacy">Privacy</Link>
          <Link to="/legal/refunds">Refunds</Link>
          <Link to="/legal/contact">Contact</Link>
        </nav>

        <div className="site-footer-note">
          <p>
            Domain availability can change. If a domain becomes unavailable after payment, we’ll contact you with alternatives or process a refund.
          </p>
          <p className="site-footer-credit">
            © 2026 {BRAND.legal.companyName} · Built by <a href="https://nodeadline.studio" target="_blank" rel="noopener noreferrer">nodeadline.studio</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
